import { OrganizationSearchResp, DatabaseId, AddSchoolRequestViewModel } from '../types/types';
import { logger } from '../utils/logger/logger';
import { getQueryParamsFromUrl } from '../utils/routing/Url';
import { GetJson, PostJson } from './Network';
import { getAddSchoolRequestUrl } from './ApiUrls';

const country = 'country';
const name = 'name';
const type = 'type';

export async function fetchProgramOrganizations(orgSearchUrl: string, searchTerm: string, countryCode?: string): Promise<OrganizationSearchResp> {
    let url;

    if (orgSearchUrl) {
        if (countryCode) {
            const typeValue = getQueryParamsFromUrl(orgSearchUrl).get('type');
            url = `${orgSearchUrl.substring(0, orgSearchUrl.indexOf('?'))}`
                + `?${country}=${countryCode}&${type}=${typeValue}&${name}=${searchTerm}`;
        } else {
            url = `${orgSearchUrl}${searchTerm}`;
        }
    }

    return fetchOrganization(url);
}

async function fetchOrganization(url: string) : Promise<OrganizationSearchResp> {
    try {
        const responseEntries = await GetJson(url) as OrganizationSearchResp;
        return responseEntries.map(entry => ({ id: entry.id, name: entry.name })) as OrganizationSearchResp;
    } catch (e) {
        logger.error(e);
    }
}

export async function addSchool(request: AddSchoolRequestViewModel) : Promise<Object> {
    return await PostJson(getAddSchoolRequestUrl(), request) as Promise<Object>;
}
